import React from 'react';

const Para = ({ text, top, left, width }) => {
  const isYAxisSpecified = Boolean(top);
  const isXAxisSpecified = Boolean(left);
  const isWidthSpecified = Boolean(width);
  return (
    <div
      className="c-cartoon-parallelogram"
      style={{
        top: isYAxisSpecified && `${top}%`,
        left: isXAxisSpecified && `${left}%`,
        width: isWidthSpecified && `${width}%`,
      }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: text,
        }}
        className="c-cartoon-parallelogram__text"
      />
    </div>
  );
};

export { Para };
